// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host {
  /*ion-item {
    margin-left: 50px;
  }*/
}
:host .beer-name {
  padding-left: 2px;
  font-size: 18px; /*1em;*/
}
:host .brewery-name {
  padding-left: 2px;
  font-size: 14px; /*0.9em;*/
}
:host .button-subtext {
  font-weight: lighter;
  text-transform: none;
  padding-left: 5px;
}
:host .button-inner {
  justify-content: flex-start;
}
:host img {
  width: auto;
  height: auto;
  display: block;
  max-width: 80px;
  max-height: 60px;
  margin: auto;
  /*margin-left: 10px;*/
  /*background: url(http://goo.gl/vyAs27) no-repeat scroll 0 0;*/
}
:host td.beer-logo {
  text-align: center;
  /*margin-left: 10px;*/
}
:host .noitems {
  margin-left: 10px;
  margin-top: 0px;
  padding-top: 0px;
  font-size: 18px;
}
:host .beer-value {
  padding-right: 10px;
}
:host .subtitle {
  padding-left: 2px;
  font-size: 11px; /*0.9em;*/
  line-height: 13px;
}`, ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
